import type { ScoreFragment } from '~/client/features/Tournaments/graphql/ScoreFragment.generated';
import LeaderboardItem from '../LeaderboardItem';

type Props = {
  leaderboard?: ScoreFragment[];
};

const topThreeUsers = 3;

const TopThree: React.FC<Props> = ({ leaderboard }) => (
  <div className="grid place-items-center gap-0.5">
    {leaderboard
      ?.slice(0, topThreeUsers)
      .map((item) => (
        <LeaderboardItem
          key={item?.id}
          username={item?.username}
          points={item?.points}
          position={item?.position}
          isMyScore={item?.isMyScore}
        />
      ))}
  </div>
);

export default TopThree;
